<template>
    <div>
        <button type="button" :class="btnClass" data-toggle="modal" :data-target="'#'+modalId">{{btnText}}</button>

        <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true">
            <div :class="'modal-dialog modal-dialog-centered '+ getModalSize">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{title}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <slot name="modalBody"></slot>
                    </div>
                    <slot name="modalFooter" v-if="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['btnClass', 'btnText', 'modalId', 'modalSize', 'title', 'footer'],
        data() {
            return {

            }
        },
        computed: {
            getModalSize() {
                if (this.modalSize == "large") {
                    return 'modal-lg'
                }
                return ''
            }
        }
    }
</script>
